import React, { useEffect, useState } from 'react'
import MyContext from './MyContext'
import axios from 'axios';
import { useNavigate } from 'react-router-dom';


const Provider = ({ children }) => {

  const [loader, setLoader] = useState(false)
  const [domain, setDomain] = useState(() => {
    const store = sessionStorage.getItem('domain')
    return store ? store : ''
  })
  const navigate = useNavigate()

  const [open, setOpen] = useState(false);
   const [name, setName] = useState(() => {
    const store = sessionStorage.getItem('name')
    return store ? store : ''
  })


  const[LogoutOpen,setLogoutOpen]=useState(false)

  const openLogoutModal = () => {
    setLogoutOpen(true)
    
  }

   const closeLogoutModal = () => {
   
    setLogoutOpen(false)
  
  }

  const handleLogout = () => {
    setLogoutOpen(false)
     sessionStorage.removeItem('login')
    sessionStorage.removeItem('path');
    setLogintime('')
    setToken('')
    sessionStorage.removeItem('token')
    setName('')
    sessionStorage.removeItem('name')
    window.location.reload('/login')
  }

  const url = 'https://backendok.vercel.app'
  // const url = 'http://localhost:5009'

  const [message, setMessage] = useState('')

 

  const [token, setToken] = useState(() => {
    const store = sessionStorage.getItem('token')
    return store ? store : ''
  })

  const [logintime, setLogintime] = useState(() => {
    const store = sessionStorage.getItem('login')
    return store ? store : ''
  })

const[dailywork,setDailywork]=useState([])


const fetchdaily = async () => {
 
  setLoader(true);
  document.querySelector("body").style.overflow = "hidden";
  try {
    const { data } = await axios.get(`${url}/daily-info`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });


    setDailywork(data.dailyInfo)

  } catch (error) {
    console.error("Error during login", error);
    alert("'refresh the page'");
  } finally {
    setLoader(false);
    document.querySelector("body").style.overflow = "auto";
  }
};
  const [work, setWork] = useState([])

  const fetchwork = async () => {
    setLoader(true);
    document.querySelector("body").style.overflow = "hidden";
    try {
      const { data } = await axios.get(`${url}/work-info`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });


      setWork(data.workInfo)

    } catch (error) {
      console.error("Error during login", error);
      alert("'refresh the page'");
    } finally {
      setLoader(false);
      document.querySelector("body").style.overflow = "auto";
    }
  };


  const [learn, setLearn] = useState([])

  const fetchlearn = async () => {
    setLoader(true);
    document.querySelector("body").style.overflow = "hidden";
    try {
      const { data } = await axios.get(`${url}/learning-data`);


      setLearn(data)

    } catch (error) {
      console.error("Error during learning", error);
      alert("'refresh the page'");
    } finally {
      setLoader(false);
      document.querySelector("body").style.overflow = "auto";
    }
  };




  const handleDelete = async (id) => {
    setLoader(true);

    try {
      const { data } = await axios.delete(`${url}/delete-user/${id}`);


      if (data.success) {
        setMessage(data.message);
        fetchuser()

      } else {
        setMessage(data.error || 'Failed to delete the user');
      }
      setOpen(true);
    } catch (error) {
      console.error('Error during comment submission:', error);
      setMessage('Something went wrong. Please try again.');
      setOpen(true);
    } finally {
      setLoader(false);
      document.body.style.overflow = 'auto';
    }
  };

  const [user, setUser] = useState([])

  const fetchuser = async () => {
    setLoader(true);
    document.querySelector("body").style.overflow = "hidden";
    try {
      const { data } = await axios.get(`${url}/register-info`);


      setUser(data.userInfo)

    } catch (error) {
      console.error("Error during login", error);
      alert("'refresh the page'");
    } finally {
      setLoader(false);
      document.querySelector("body").style.overflow = "auto";
    }
  };

  const [usertoken, setUsertoken] = useState([])

  const fetchusertoken = async () => {
    if (!token) {
      console.warn("No token found. Unable to fetch user token.");
      return;
    }
  
    setLoader(true);
    document.querySelector("body").style.overflow = "hidden";
  
    try {
      const { data } = await axios.get(`${url}/register-token`, {
        headers: { Authorization: `Bearer ${token}` },
      });
  
      setUsertoken(data.userInfo);
    } catch (error) {
      console.error("Error during login:", error);
      alert("An error occurred. Please refresh the page.");
    } finally {
      setLoader(false);
      document.querySelector("body").style.overflow = "auto";
    }
  };
  

  const [input, setInput] = useState({});

  

  const handleCommentdaily = async (id) => {

    const comment = input[id]?.trim();

    if (!comment) {
      setOpen(true);
      setMessage('Please fill in the comment');
      return;
    }

    setLoader(true);
    document.body.style.overflow = 'hidden';

    try {
      const { data } = await axios.post(
        `${url}/daily-submit`,
        { id, comment },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (data.success) {
        setMessage(data.message);
        fetchdaily()
        setInput((prev) => ({ ...prev, [id]: '' }));
      } else {
        setMessage(data.error || 'Failed to submit the comment');
      }
      setOpen(true);
    } catch (error) {
      console.error('Error during comment submission:', error);
      setMessage('Something went wrong. Please try again.');
      setOpen(true);
    } finally {
      setLoader(false);
      document.body.style.overflow = 'auto';
    }
  };
  const handleComment = async (id) => {

    const comment = input[id]?.trim();

    if (!comment) {
      setOpen(true);
      setMessage('Please fill in the comment');
      return;
    }

    setLoader(true);
    document.body.style.overflow = 'hidden';

    try {
      const { data } = await axios.post(
        `${url}/work-submit`,
        { id, comment },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (data.success) {
        setMessage(data.message);
        fetchwork()
        setInput((prev) => ({ ...prev, [id]: '' }));
      } else {
        setMessage(data.error || 'Failed to submit the comment');
      }
      setOpen(true);
    } catch (error) {
      console.error('Error during comment submission:', error);
      setMessage('Something went wrong. Please try again.');
      setOpen(true);
    } finally {
      setLoader(false);
      document.body.style.overflow = 'auto';
    }
  };


  const handleNavClick = (path) => {
    navigate(path);
    sessionStorage.setItem('path', path);
  };

  const fetchAtten = async () => {
  
    setLoader(true);

    try {
      const { data } = await axios.get(`${url}/attendance-info`);
    
      const sortedData = data.sort((a, b) => b._id.localeCompare(a._id));

      setAdata(sortedData);
    } catch (error) {
      console.error('Error fetching attendance data:', error);
     
    } finally {
      setLoader(false);
    }
  };

  const [adata, setAdata] = useState([])

  const [am, setAm] = useState(false)

  const handleOpenModal = () => {
    setAm(true)
    document.querySelector('body').style.overflow = 'hidden';
  }

  const handleCloseModal = () => {
    setAm(false)
    document.querySelector('body').style.overflow = 'auto';
  }

   
  useEffect(() => {
    if(token){
    fetchusertoken()
    }
  },[])

  return (
    <MyContext.Provider value={{handleLogout,LogoutOpen,setLogoutOpen,openLogoutModal,closeLogoutModal,handleCommentdaily,dailywork,setDailywork,fetchdaily, fetchusertoken, usertoken, domain, setDomain, learn, setLearn, fetchlearn, handleDelete, user, setUser, fetchuser, handleOpenModal, handleCloseModal, am, setAm, adata, fetchAtten, setAdata, handleNavClick, logintime, setLogintime, url, handleComment, input, setInput, fetchwork, work, setWork, name, setName, token, setToken, message, setMessage, open, setOpen, loader, setLoader }}>
      {children}
    </MyContext.Provider>
  )
}

export default Provider